import { ChevronDownIcon } from "@heroicons/react/24/solid";

interface AccordionTitleChevronProps {
  open: boolean;
}

export default function AccordionTitleChevron({ open }: AccordionTitleChevronProps) {
  return (
    <ChevronDownIcon
      className={`h-4 w-4 text-gray-500 shrink-0 transition-transform ${
        open ? "rotate-180" : ""
      }`}
    />
  );
}
